import request from '@/core/http/request'

//查询设置信息
export function setting_query_all(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysSettingConfig/list',
        method: 'post',
        data: data
    })
}

//新增设置信息
export function setting_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysSettingConfig/add',
        method: 'post',
        data: data
    })
}

//修改设置信息
export function setting_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysSettingConfig/update',
        method: 'post',
        data: data
    })
}

//获取是否展示列表配置
export function getSettingByKey(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysUserMenu/isDisplaySetting',
        method: 'post',
        data: data
    })
} 

//根据Key查设置方法
export function getSettingByKeyAll(data) {
    return request({
        url: '/qingguang/tenantbussiness/sysSettingConfig/getSettingByKey',
        method: 'post',
        data: data
    })
} 

//根据Key查设置方法
export function getSettingBySwitchKey(data) {
    return request({
        url: '/qingguang/tenantbussiness/characteristicSwitch/getCharacteristicSwitchByKey',
        method: 'post',
        data: data
    })
} 